import { render, staticRenderFns } from "./CsAsignacionContableIndex.vue?vue&type=template&id=4a64a8a3"
import script from "./CsAsignacionContableIndex.vue?vue&type=script&lang=js"
export * from "./CsAsignacionContableIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports